import httpService from './httpService';
import {KBResourceRestService, newGenericRestRequest} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

var service = {};

service.getKBResourceById = async (kbResourceId) => {
  const token = storageService.getItem('token');
  const requestObj = {
    endpoint: 'byId',
    endpointParam: kbResourceId,
    token,
  };
  const response = await KBResourceRestService.get(requestObj, {token});
  utilsService.logApiResponse('getKBResourceById', response.data);
  return response.data;
};

service.getKBResourcesByOwner = async (ownerType, ownerId) => {
  const token = storageService.getItem('token');
  const requestObj = {
    endpoint: 'ownerType',
    endpointParam: ownerType,
    endpoint2: 'ownerId',
    endpointParam2: ownerId,
    token,
  };
  const response = await KBResourceRestService.get(requestObj, {token});
  utilsService.logApiResponse('getKBResourcesByOwner', response.data);
  return response.data;
};

service.getKBResourcesByKBRTypeAndOwner = async (
  ownerType,
  ownerId,
  kbResourceType,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    endpoint: 'byType',
    endpointParam: kbResourceType,
    endpoint2: 'ownerType',
    endpointParam2: ownerType,
    endpoint3: 'ownerId',
    endpointParam3: ownerId,
    token,
  };
  const response = await KBResourceRestService.get(requestObj, {token});
  utilsService.logApiResponse('getKBResourcesByKBRTypeAndOwner', response.data);
  return response.data;
};

service.createKBResource = async (kbResourceDto) => {
  const token = storageService.getItem('token');
  const requestObj = {
    kbResourceDto,
    token,
  };
  const response = await KBResourceRestService.save({}, requestObj);
  utilsService.logApiResponse('createKBResource', response.data);
  return response.data;
};

service.createKBResourceForFile = async (kbResourceDto) => {
  const token = storageService.getItem('token');
  const requestObj = {
    kbResourceDto,
    token,
  };
  const response = await KBResourceRestService.save(
    {endpoint: 'file'},
    requestObj,
  );
  utilsService.logApiResponse('createKBResourceForFile', response.data);
  return response.data;
};

service.createKbResourceQaSuggestions = async (
  kbResourceId,
  ownerObjectType,
  ownerObjectId,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    token,
    kbResourceId,
    ownerObjectType,
    ownerObjectId,
  };
  const response = await KBResourceRestService.save(
    {endpoint: 'qaSuggestions'},
    requestObj,
  );
  utilsService.logApiResponse('createKbResourceQaSuggestions', response.data);
  return response.data;
};

service.createKbResourceQaFromChat = async (chatMessageId) => {
  const token = storageService.getItem('token');
  const requestObj = {
    token,
    chatMessageId,
  };
  const response = await KBResourceRestService.save(
    {endpoint: 'qaFromChat'},
    requestObj,
  );
  utilsService.logApiResponse('createKbResourceQaFromChat', response.data);
  return response.data;
};

service.updateKBResource = async (kbResourceDto) => {
  const token = storageService.getItem('token');
  const requestObj = {
    kbResourceDto,
    token,
  };
  const response = await KBResourceRestService.update({}, requestObj);
  utilsService.logApiResponse('updateKBResource', response.data);
  return response.data;
};

service.deleteKBResource = async (kbResourceId) => {
  const token = storageService.getItem('token');
  const response = await KBResourceRestService.delete(
    {endpoint: kbResourceId},
    {token},
  );
  utilsService.logApiResponse('deleteKBResource', response.data);
  return response.data;
};

service.invalidateKBResources = async (
  kbResourceIds,
  ownerObjectType,
  ownerObjectId,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    token,
    kbResourceIds,
    ownerObjectType,
    ownerObjectId,
  };
  const response = await KBResourceRestService.update(
    {endpoint: 'invalidate'},
    requestObj,
  );
  utilsService.logApiResponse('invalidateKBResources', response.data);
  return response.data;
};

service.uploadFileToS3 = async (
  base64,
  tempAccessUrl,
  progress,
  cancelTokenCallback,
) => {
  try {
    const cancelTokenSource = httpService.cancelToken.source();
    cancelTokenCallback(cancelTokenSource);
    const response = await newGenericRestRequest('put', tempAccessUrl, base64, {
      onUploadProgress: (progressEvent) =>
        progress(
          Number(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2),
          ),
        ),
      cancelToken: cancelTokenSource.token,
    });
    if (response.status === 200) {
      response.success = true; //success is added for logApiResponse since it is missing in the response
      utilsService.logApiResponse('KbResource uploadFileToS3', response);
      return true;
    }
    return false;
  } catch (error) {
    utilsService.logApiResponse('KbResource uploadFileToS3 error', error);
  }
};

service.confirmFileUpload = async (kbResourceId) => {
  try {
    const response = await KBResourceRestService.save(
      {
        endpoint: 'uploadConfirmed',
        endpointParam: kbResourceId,
      },
      {
        token: storageService.getItem('token'),
      },
    );
    utilsService.logApiResponse('confirmFileUpload', response.data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    utilsService.logApiResponse('confirmFileUpload error', error);
  }
};

service.getKbFileAccessUrlById = async (kbResourceId) => {
  const token = storageService.getItem('token');
  const requestObj = {
    endpoint: 'file/byId',
    endpointParam: kbResourceId,
    token,
  };
  const response = await KBResourceRestService.get(requestObj, {token});
  utilsService.logApiResponse('getKbFileAccessUrlById', response.data);
  return response.data;
};

service.extractSitemap = async (
  sitemapLink,
  ownerObjectType,
  ownerObjectId,
  linkCount,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    sitemapLink,
    ownerObjectType,
    ownerObjectId,
    token,
  };
  if (linkCount) {
    requestObj.linkCount = linkCount;
  }
  const response = await KBResourceRestService.save(
    {endpoint: 'sitemap'},
    requestObj,
  );
  utilsService.logApiResponse('extractSitemap', response.data);
  return response.data;
};

service.crawlWebsite = async (
  siteLink,
  ownerObjectType,
  ownerObjectId,
  linkCount,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    siteLink,
    ownerObjectType,
    ownerObjectId,
    token,
  };
  if (linkCount) {
    requestObj.linkCount = linkCount;
  }
  const response = await KBResourceRestService.save(
    {endpoint: 'crawl'},
    requestObj,
  );
  utilsService.logApiResponse('crawlWebsite', response.data);
  return response.data;
};

service.getKBCrawlFlowDtoByOwnerAndStatus = async (
  ownerType,
  ownerId,
  status,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    endpoint: 'crawl/ownerType',
    endpointParam: ownerType,
    endpoint2: 'ownerId',
    endpointParam2: ownerId,
    endpoint3: 'status',
    endpointParam3: status,
    token,
  };
  const response = await KBResourceRestService.get(requestObj, {token});
  utilsService.logApiResponse(
    'getKBCrawlFlowDtoByOwnerAndStatus',
    response.data,
  );
  return response.data;
};

service.stopCrawl = async (ownerObjectType, ownerObjectId) => {
  const token = storageService.getItem('token');
  const response = await KBResourceRestService.delete(
    {
      endpoint: 'crawl/ownerType',
      endpointParam: ownerObjectType,
      endpoint2: 'ownerId',
      endpointParam2: ownerObjectId,
    },
    {token},
  );
  utilsService.logApiResponse('stopCrawl', response.data);
  return response.data;
};

const kbResourceService = {...service};
export default kbResourceService;
